<template>
  <div id="app">
    <div>
        <div><Card icon="bookshelf-icon.png" text="Bøger" clickurl="https://cloud.collectorz.com/275242/books/"  /></div>
        <div><Card icon="filmreel-icon.png" text="Film" clickurl="https://cloud.collectorz.com/275242/movies/"/></div>
        <div><Card icon="mic-icon.png" text="Musik" clickurl="https://cloud.collectorz.com/275242/music/"/></div>
      </div>
    
  </div>
</template>

<script>
//import Vue from "vue";
//import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
//import "bootstrap/dist/css/bootstrap.css";
//import "bootstrap-vue/dist/bootstrap-vue.css";
//Vue.use(BootstrapVue);

import Card from "./components/Card.vue";

export default {
  name: "App",
  components: {
    Card
  }
};
</script>

<style>
</style>
